// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';

// IMPORT LIBRARIES
import $ from 'jquery';

// IMPORT COMPONENTS
import '@pj/assets/images/svg/logo_light.svg';
import Utils from '@core/base/scripts/utils/utils';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';


class FooterCollapse {

  constructor() {
    this.filled = false;
    this.$list = null;
    this.$lastSelectedItem = null;
    this.$list = null;
    this.$collapseBtn = null;
  }

  init() {
    const $footer = $('.footer');
    this.$collapseBtn = $('.footer__col__title', $footer);

    if (Utils.isTablet) {
      this.buildCollapseBtn();
    } else {
      this.destroy();
    }
  }

  buildCollapseBtn() {
    this.$collapseBtn.each((i, e) => {
      const id = $(e).data('controls');
      $(e)
        .off()
        .attr('role', 'button')
        .attr(A11yUtils.ARIA.expanded, false)
        .attr(A11yUtils.ARIA.controls, id)
        .attr('tabindex', 0);
    });


    this.$collapseBtn.on('keydown', e => {
      if (e.which === A11yUtils.keyboard.space || e.which === A11yUtils.keyboard.enter) {
        this.collapse(e);
        return false;
      }
      return true;
    });

    this.$collapseBtn.on('click', e => {
      e.preventDefault();
      this.collapse(e);
    });
  }


  collapse(e) {
    const $btn = $(e.currentTarget);
    const id = $(e.currentTarget).data('controls');
    this.$list = $(`#${id}`);
    this.$list.slideToggle(() => {
      const expanded = $btn.attr(A11yUtils.ARIA.expanded) === 'true';
      if (!expanded) {
        this.$list.find(A11yUtils.FOCUSABLES)[0].focus();
        $btn.attr(A11yUtils.ARIA.expanded, true);
      } else {
        $btn.focus();
        $btn.attr(A11yUtils.ARIA.expanded, false);
      }
    });
  }

  destroy() {
    if (this.$collapseBtn && this.$list) {
      this.$collapseBtn
        .off()
        .removeAttr('role')
        .removeAttr(A11yUtils.ARIA.expanded)
        .removeAttr(A11yUtils.ARIA.controls)
        .removeAttr('tabindex');
      this.$list.removeAttr('style');
    }
  }
}

const footerCollapse = new FooterCollapse();
const footerModule = new BaseModule();
footerModule.name = 'footer';
footerModule.init(() => {
  footerCollapse.init();
});

footerModule.onResize(function () {
  if (footerCollapse) {
    footerCollapse.init();
  }
});
